// Minimal i18n scaffold: a typed string catalog + t(). Multi-language TTS/UI can swap
// the active dictionary later; for now every user-facing string routes through here so
// nothing is hardcoded in components.
const en = {
  'app.name': 'Alignova',
  'nav.dashboard': 'Dashboard',
  'nav.workflow': 'Lab Workflow',
  'nav.cases': 'Cases',
  'nav.clinics': 'Clinics',
  'nav.patients': 'Patients',
  'nav.mediaReview': 'Media review',
  'nav.grading': 'Grading',
  'nav.manufacturing': 'Manufacturing',
  'nav.fieldTracking': 'Field tracking',
  'nav.fieldReports': 'Field reports',
  'nav.invoices': 'Invoices',
  'nav.accounting': 'Accounting',
  'nav.fieldTeam': 'Field team',
  'nav.payments': 'Payments',
  'nav.expenses': 'Expenses',
  'nav.priceBook': 'Price book',
  'nav.users': 'Users',
  'nav.notifications': 'Notifications',
  'nav.settings': 'Settings',
  'nav.rbac': 'Roles & Permissions',
  'nav.audit': 'Audit Log',
  'nav.security': 'Security',
  'nav.chat': 'Chat',
  'nav.leads': 'Website Leads',
  'nav.signOut': 'Sign out',
  'login.title': 'Sign in',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.error': 'Invalid username or password',
  'common.loading': 'Loading…',
  'common.forbidden': "You don't have permission to view this.",
  'common.notFound': 'Page not found',
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Welcome, {name}',
  'dashboard.metrics.title': 'Live metrics',
  'dashboard.metric.total': 'Total cases',
  'dashboard.metric.inProduction': 'In production',
  'dashboard.metric.remake': 'Remake',
  'dashboard.metric.delayed': 'Delayed',
  'dashboard.metric.dueSoon': 'Due soon',
  'dashboard.breakdown.title': 'Status breakdown',
  // Patient app + HR (M8)
  'patientApp.title': 'Your treatment',
  'patientApp.loadError': "Couldn't load your case",
  'patientApp.currentStage': 'Current stage',
  'patientApp.expectedDelivery': 'Expected delivery',
  'patientApp.timeline': 'Progress',
  'hrApp.title': 'HR',
  'hrApp.subtitle': 'People & payroll',
  'hrApp.placeholder': 'HR features are coming soon.',
  // Notifications (M9)
  'notifications.title': 'Notifications',
  'notifications.subtitle': 'Outbound message outbox and delivery status',
  'notifications.process': 'Process pending',
  'notifications.retry': 'Retry',
  'notifications.cancel': 'Cancel',
  'notifications.empty': 'No notifications yet',
  'notifications.loadError': 'Failed to load notifications',
  'notifications.processError': 'Failed to process pending notifications',
  'notifications.retryError': 'Failed to retry notification',
  'notifications.cancelError': 'Failed to cancel notification',
  'notifications.col.created': 'Created',
  'notifications.col.channel': 'Channel',
  'notifications.col.recipient': 'Recipient',
  'notifications.col.template': 'Template',
  'notifications.col.status': 'Status',
  'notifications.col.attempts': 'Attempts',
  'notifications.col.actions': 'Actions',
  'notifications.status.pending': 'Pending',
  'notifications.status.sent': 'Sent',
  'notifications.status.failed': 'Failed',
  'notifications.status.cancelled': 'Cancelled',
  'rbac.title': 'Roles & Permissions',
  'rbac.subtitle': 'Toggle permissions per role. Overrides layer on top of role defaults.',
  'audit.title': 'Audit Log',
  'audit.subtitle': 'Every state-changing action, newest first.',
  'sync.live': 'Live',
  'sync.connecting': 'Connecting…',
  'sync.offline': 'Offline',
  'sync.pending': '{count} pending',
  'sync.queued': 'Saved offline - this change will sync when you reconnect.',
  // Cases (M1)
  'cases.title': 'Cases',
  'cases.subtitle': 'Track every case across the lab workflow.',
  'cases.view.board': 'Board',
  'cases.view.list': 'List',
  'cases.new': 'New case',
  'cases.advance': 'Advance',
  'cases.approve': 'Approve setup',
  'cases.approveError': "Couldn't approve setup",
  'cases.offBoard': 'Off-board',
  'cases.laneEmpty': 'No cases',
  'cases.empty': 'No cases yet.',
  'cases.loadError': 'Failed to load cases',
  'cases.advanceError': "Couldn't advance case",
  'cases.searchPlaceholder': 'Search cases…',
  'cases.col.caseNumber': 'Case #',
  'cases.col.client': 'Client',
  'cases.col.service': 'Service',
  'cases.col.status': 'Status',
  'cases.col.priority': 'Priority',
  'cases.col.due': 'Due',
  'cases.col.updated': 'Updated',
  'cases.col.files': 'Files',
  // Case files (upload/download)
  'cases.files.open': 'Files',
  'cases.files.title': 'Case files - {case}',
  'cases.files.empty': 'No files uploaded yet.',
  'cases.files.loadError': "Couldn't load case files",
  'cases.files.uploadHeading': 'Upload a file',
  'cases.files.choose': 'Choose file',
  'cases.files.kind': 'Type',
  'cases.files.kindAuto': 'Auto-detect',
  'cases.files.caption': 'Caption (optional)',
  'cases.files.upload': 'Upload',
  'cases.files.uploading': 'Uploading…',
  'cases.files.uploadError': "Couldn't upload the file",
  'cases.files.tooLargeHint': 'Max 500 MB. Supported: STL, OBJ, PLY, 3MF, images, video, PDF.',
  'cases.files.download': 'Download',
  'cases.files.view3d': '◈ 3D',
  'cases.files.legacyRef': 'Reference only - no stored file',
  // 3D model viewer
  'cases.model.loading': 'Loading model…',
  'cases.model.error': "Couldn't load this 3D model",
  'cases.model.close': 'Close',
  'cases.model.hint': 'Drag to rotate · scroll to zoom · right-drag to pan',
  'cases.files.close': 'Close',
  'cases.files.col.file': 'File',
  'cases.files.col.kind': 'Type',
  'cases.files.col.size': 'Size',
  'cases.files.col.status': 'Status',
  'cases.files.col.uploaded': 'Uploaded',
  // Case detail page
  'cases.detail.back': '← Back to cases',
  'cases.detail.loadError': "Couldn't load this case",
  'cases.detail.notFound': 'This case no longer exists.',
  'cases.tab.overview': 'Overview',
  'cases.tab.files': 'Files',
  'cases.tab.timeline': 'Timeline',
  'cases.detail.field.type': 'Type',
  'cases.detail.field.service': 'Service',
  'cases.detail.field.client': 'Client',
  'cases.detail.field.patientCode': 'Patient code',
  'cases.detail.field.arch': 'Arch',
  'cases.detail.field.tooth': 'Tooth',
  'cases.detail.field.stages': 'Aligner stages (upper / lower)',
  'cases.detail.field.material': 'Aligner material',
  'cases.detail.field.priority': 'Priority',
  'cases.detail.field.status': 'Status',
  'cases.detail.field.due': 'Due date',
  'cases.detail.field.received': 'Received',
  'cases.detail.field.assignedTo': 'Assigned to',
  'cases.detail.field.relation': 'Relation',
  'cases.detail.field.refinementRound': 'Refinement round',
  'cases.detail.field.setupApproved': 'Setup approved',
  'cases.detail.field.notes': 'Notes',
  'cases.detail.none': '-',
  'cases.timeline.empty': 'No history yet.',
  'cases.timeline.created': 'Case created',
  'cases.tab.grading': 'Grading',
  'cases.tab.comments': 'Comments',
  'cases.tab.chat': 'Chat',
  'cases.tab.requests': 'Requests',
  'cases.tab.checklist': 'Checklist',
  'cases.tab.plans': 'Plans',
  // Comments
  'cases.comments.empty': 'No comments yet.',
  'cases.comments.placeholder': 'Add an internal note…',
  'cases.comments.post': 'Post',
  'cases.comments.error': "Couldn't post the comment",
  // Chat
  'cases.chat.empty': 'No messages yet.',
  'cases.chat.placeholder': 'Type a message…',
  'cases.chat.send': 'Send',
  'cases.chat.error': "Couldn't send the message",
  // Requests
  'cases.requests.empty': 'No requests.',
  'cases.requests.new': 'New request',
  'cases.requests.kind': 'Type',
  'cases.requests.kind.change': 'Change request',
  'cases.requests.kind.cancel': 'Cancellation',
  'cases.requests.requestType': 'Category (optional)',
  'cases.requests.description': 'Description',
  'cases.requests.submit': 'Submit request',
  'cases.requests.approve': 'Approve',
  'cases.requests.reject': 'Reject',
  'cases.requests.error': "Couldn't save the request",
  'cases.requests.reviewError': "Couldn't review the request",
  'cases.requests.pendingCard': 'Pending requests',
  // Checklist
  'cases.checklist.empty': 'No checklist items.',
  'cases.checklist.add': 'Add item',
  'cases.checklist.placeholder': 'New checklist item…',
  'cases.checklist.save': 'Save checklist',
  'cases.checklist.saving': 'Saving…',
  'cases.checklist.error': "Couldn't save the checklist",
  // Treatment plans
  'cases.plans.empty': 'No treatment plans yet.',
  'cases.plans.title': 'Title',
  'cases.plans.notes': 'Notes',
  'cases.plans.mediaId': 'Linked file id (optional)',
  'cases.plans.add': 'Add plan',
  'cases.plans.delete': 'Delete',
  'cases.plans.error': "Couldn't save the plan",
  'cases.plans.no': 'Plan',
  // Overview additions
  'cases.detail.field.punching': 'Punching',
  'cases.detail.field.turnaround': 'Turnaround (received → now)',
  // Sidebar actions
  'cases.detail.requestRevision': 'Request revision',
  'cases.detail.revisionError': "Couldn't request a revision",
  'cases.detail.delete': 'Delete case',
  'cases.detail.deleteConfirm': 'Delete this case? It will be hidden from all boards and lists.',
  'cases.detail.deleteError': "Couldn't delete the case",
  // Files: delete + visibility
  'cases.files.delete': 'Delete',
  'cases.files.deleteConfirm': 'Delete this file?',
  'cases.files.deleteError': "Couldn't delete the file",
  'cases.files.visible': 'Shared',
  'cases.files.hidden': 'Private',
  'cases.files.visibilityError': "Couldn't change sharing",
  // Workflow sidebar
  'cases.detail.workflow': 'Workflow',
  'cases.detail.assignedStaff': 'Assigned staff',
  'cases.detail.history': 'Status history',
  'cases.detail.assignUnassigned': 'Unassigned',
  'cases.detail.assignError': "Couldn't reassign the case",
  'cases.detail.statusError': "Couldn't change the status",
  'cases.detail.qcPass': '✓ QC pass',
  // Grading tab
  'cases.detail.notGraded': 'Not graded yet.',
  'cases.detail.viewGrading': 'Open grading →',
  'cases.grade.grade': 'Grade',
  'cases.grade.classification': 'Classification',
  'cases.grade.findings': 'Findings',
  'cases.grade.shade': 'Shade',
  'cases.grade.status': 'Status',
  'cases.grade.lockedPrice': 'Locked unit price',
  'cases.grade.status.draft': 'Draft',
  'cases.grade.status.approved': 'Approved',
  'cases.form.title': 'New case',
  'cases.form.caseType': 'Case type',
  'cases.form.arch': 'Arch',
  'cases.form.archNone': '- Select arch -',
  'cases.form.houseClient': '- House / walk-in -',
  'cases.form.walkInName': 'Walk-in client name',
  'cases.form.totalStagesUpper': 'Total stages (upper)',
  'cases.form.totalStagesLower': 'Total stages (lower)',
  'cases.form.material': 'Aligner material',
  'cases.form.clientName': 'Client name',
  'cases.form.service': 'Service',
  'cases.form.patientCode': 'Patient code',
  'cases.form.tooth': 'Tooth',
  'cases.form.priority': 'Priority',
  'cases.form.dueDate': 'Due date',
  'cases.form.notes': 'Notes',
  'cases.form.cancel': 'Cancel',
  'cases.form.submit': 'Create case',
  'cases.form.saving': 'Saving…',
  'cases.form.invalid': 'Please check the form and try again.',
  'cases.form.saveError': 'Failed to create case',
  // Clinics (M2)
  'clinics.title': 'Clinics',
  'clinics.subtitle': 'Manage the practices that send cases to the lab.',
  'clinics.new': 'New clinic',
  'clinics.edit': 'Edit',
  'clinics.activate': 'Activate',
  'clinics.deactivate': 'Deactivate',
  'clinics.empty': 'No clinics yet.',
  'clinics.searchPlaceholder': 'Search clinics…',
  'clinics.loadError': "Couldn't load clinics",
  'clinics.toggleError': "Couldn't update clinic status",
  'clinics.status.active': 'Active',
  'clinics.status.inactive': 'Inactive',
  'clinics.col.code': 'Code',
  'clinics.col.name': 'Name',
  'clinics.col.type': 'Type',
  'clinics.col.city': 'City',
  'clinics.col.status': 'Status',
  'clinics.col.login': 'Portal login',
  'clinics.col.actions': 'Actions',
  'clinics.portal.button': 'Portal',
  'clinics.portal.only': 'Portal login',
  'clinics.portal.none': 'No login',
  'clinics.portal.active': 'Active',
  'clinics.portal.disabled': 'Disabled',
  'clinics.portal.section': 'Clinic portal access',
  'clinics.portal.saveFirst': 'Save the clinic first, then grant portal access.',
  'clinics.portal.username': 'Username',
  'clinics.portal.displayName': 'Display name',
  'clinics.portal.email': 'Email (optional)',
  'clinics.portal.password': 'Password',
  'clinics.portal.newPassword': 'New password',
  'clinics.portal.create': 'Create portal login',
  'clinics.portal.reset': 'Reset password',
  'clinics.portal.disable': 'Disable login',
  'clinics.portal.enable': 'Enable login',
  'clinics.portal.existing': 'Portal login',
  'clinics.portal.created': 'Portal login created. Share the username and password with the clinic.',
  'clinics.portal.resetDone': 'Password reset. Share the new password with the clinic.',
  'clinics.portal.statusChanged': 'Portal login updated.',
  'clinics.portal.hint': 'The clinic signs in at the normal login page with this username and password.',
  'clinics.portal.error': 'Could not update portal access.',
  'clinics.form.createTitle': 'New clinic',
  'clinics.form.editTitle': 'Edit clinic',
  'clinics.form.clinicCode': 'Clinic code',
  'clinics.form.clientType': 'Type',
  'clinics.form.name': 'Name',
  'clinics.form.dentistName': 'Dentist name',
  'clinics.form.contactPerson': 'Contact person',
  'clinics.form.codeAuto': 'Assigned automatically',
  'clinics.form.codeAutoHint': 'Leave blank and the next code in the lab’s series is used.',
  'clinics.form.mobile': 'Mobile',
  'clinics.form.mobileRequired': 'A mobile number is required — it is what identifies this clinic.',
  'clinics.form.whatsapp': 'WhatsApp',
  'clinics.form.email': 'Email',
  'clinics.form.city': 'City',
  'clinics.form.address': 'Address',
  'clinics.form.notes': 'Notes',
  'clinics.form.invalid': 'Please check the form and try again.',
  'clinics.form.saveError': "Couldn't save clinic",
  'clinics.form.cancel': 'Cancel',
  'clinics.form.saving': 'Saving…',
  'clinics.form.submit': 'Save',
  // Patients (M3)
  'patients.title': 'Patients',
  'patients.subtitle': 'Manage the patients treated across lab cases.',
  'patients.new': 'New patient',
  'patients.edit': 'Edit',
  'patients.empty': 'No patients yet.',
  'patients.loadError': "Couldn't load patients",
  'patients.searchPlaceholder': 'Search patients…',
  'patients.status.active': 'Active',
  'patients.status.inactive': 'Inactive',
  'patients.col.code': 'Code',
  'patients.col.name': 'Name',
  'patients.col.phone': 'Phone',
  'patients.col.status': 'Status',
  'patients.col.actions': 'Actions',
  'patients.sex.unspecified': 'Unspecified',
  'patients.sex.male': 'Male',
  'patients.sex.female': 'Female',
  'patients.sex.other': 'Other',
  'patients.form.createTitle': 'New patient',
  'patients.form.editTitle': 'Edit patient',
  'patients.form.fullName': 'Full name',
  'patients.form.sex': 'Sex',
  'patients.form.dateOfBirth': 'Date of birth',
  'patients.form.phone': 'Phone',
  'patients.form.whatsapp': 'WhatsApp',
  'patients.form.email': 'Email',
  'patients.form.notes': 'Notes',
  'patients.form.invalid': 'Please check the form and try again.',
  'patients.form.saveError': "Couldn't save patient",
  'patients.form.cancel': 'Cancel',
  'patients.form.saving': 'Saving…',
  'patients.form.submit': 'Save',
  'patients.media.title': 'Media review',
  'patients.media.subtitle': 'Approve or reject patient-submitted media.',
  'patients.media.empty': 'Nothing awaiting review.',
  'patients.media.loadError': "Couldn't load pending media",
  'patients.media.reviewError': "Couldn't submit review",
  'patients.media.approve': 'Approve',
  'patients.media.reject': 'Reject',
  // Grading (M4)
  'grading.title': 'Grading',
  'grading.subtitle': 'Grade cases and lock pricing.',
  'grading.empty': 'No cases yet.',
  'grading.loadError': "Couldn't load cases",
  'grading.searchPlaceholder': 'Search cases…',
  'grading.open': 'Grade',
  'grading.col.caseNumber': 'Case #',
  'grading.col.client': 'Client',
  'grading.col.service': 'Service',
  'grading.col.actions': 'Actions',
  'grading.editor.title': 'Grade case',
  'grading.editor.grade': 'Grade',
  'grading.editor.classification': 'Classification',
  'grading.editor.classificationNone': '- None -',
  'grading.editor.findings': 'Findings',
  'grading.editor.shade': 'Shade',
  'grading.editor.remakeChargeBps': 'Remake charge (bps)',
  'grading.editor.status.draft': 'Draft',
  'grading.editor.status.approved': 'Approved',
  'grading.editor.lockedPrice': 'Locked unit price',
  'grading.editor.loading': 'Loading…',
  'grading.editor.loadError': "Couldn't load grade",
  'grading.editor.invalid': 'Please check the form and try again.',
  'grading.editor.saveError': "Couldn't save grade",
  'grading.editor.approve': 'Approve & lock price',
  'grading.editor.approveError': "Couldn't approve grade",
  'grading.editor.reopen': 'Reopen',
  'grading.editor.reopenError': "Couldn't reopen grade",
  'grading.editor.save': 'Save',
  'grading.editor.saving': 'Saving…',
  'grading.editor.close': 'Close',
  // Finance — price book (M5)
  'finance.price.title': 'Price book',
  'finance.price.subtitle': 'Service prices by grade, with tax.',
  'finance.price.add': 'Add / update price',
  'finance.price.loadError': "Couldn't load price book",
  'finance.price.empty': 'No prices yet.',
  'finance.price.defaultGrade': '- default -',
  'finance.price.col.service': 'Service',
  'finance.price.col.grade': 'Grade',
  'finance.price.col.unitPrice': 'Unit price',
  'finance.price.col.tax': 'Tax',
  'finance.price.col.active': 'Active',
  'finance.price.status.active': 'Active',
  'finance.price.status.inactive': 'Inactive',
  'finance.price.form.title': 'Add / update price',
  'finance.price.form.service': 'Service',
  'finance.price.form.grade': 'Grade',
  'finance.price.form.unitPrice': 'Unit price (PKR)',
  'finance.price.form.tax': 'Tax',
  'finance.price.form.taxNone': '- No tax -',
  'finance.price.form.invalid': 'Please check the form and try again.',
  'finance.price.form.saveError': "Couldn't save price",
  'finance.price.form.cancel': 'Cancel',
  'finance.price.form.saving': 'Saving…',
  'finance.price.form.submit': 'Save',
  // Finance — invoices
  'finance.invoices.title': 'Invoices',
  'finance.invoices.subtitle': 'Issue and track invoices.',
  'finance.invoices.new': 'New invoice',
  'finance.invoices.loadError': "Couldn't load invoices",
  'finance.invoices.voidError': "Couldn't void invoice",
  'finance.invoices.empty': 'No invoices yet.',
  'finance.invoices.void': 'Void invoice',
  'finance.invoices.col.number': 'Invoice #',
  'finance.invoices.col.client': 'Client',
  'finance.invoices.col.date': 'Date',
  'finance.invoices.col.total': 'Total',
  'finance.invoices.col.paid': 'Paid',
  'finance.invoices.col.status': 'Status',
  'finance.invoices.status.draft': 'Draft',
  'finance.invoices.status.issued': 'Issued',
  'finance.invoices.status.partial': 'Partial',
  'finance.invoices.status.paid': 'Paid',
  'finance.invoices.status.void': 'Void',
  'finance.invoices.line.service': 'Service',
  'finance.invoices.line.grade': 'Grade',
  'finance.invoices.line.qty': 'Qty',
  'finance.invoices.line.unitPrice': 'Unit price',
  'finance.invoices.line.lineTotal': 'Line total',
  // Finance — invoice builder
  'finance.builder.title': 'New invoice',
  'finance.builder.clinic': 'Clinic',
  'finance.builder.clinicNone': '- House / walk-in -',
  'finance.builder.clientName': 'Client name',
  'finance.builder.cases': 'Cases',
  'finance.builder.casesEmpty': 'No cases available.',
  'finance.builder.casesHint': 'Selected cases are priced on create.',
  'finance.builder.manualLines': 'Manual lines',
  'finance.builder.addLine': 'Add line',
  'finance.builder.line.service': 'Service',
  'finance.builder.line.qty': 'Qty',
  'finance.builder.line.unitPrice': 'Unit price',
  'finance.builder.line.taxNone': 'No tax',
  'finance.builder.discountType': 'Discount',
  'finance.builder.discount.none': 'None',
  'finance.builder.discount.percent': 'Percent',
  'finance.builder.discount.flat': 'Flat amount',
  'finance.builder.discountValue': 'Discount value',
  'finance.builder.delivery': 'Delivery charges (PKR)',
  'finance.builder.previewLabel': 'Manual lines preview',
  'finance.builder.preview.subtotal': 'Subtotal',
  'finance.builder.preview.discount': 'Discount',
  'finance.builder.preview.tax': 'Tax',
  'finance.builder.preview.delivery': 'Delivery',
  'finance.builder.preview.total': 'Total',
  'finance.builder.preview.casesPricedOnCreate': 'Selected cases will be priced on create and added to this total.',
  'finance.builder.invalid': 'Please check the form and try again.',
  'finance.builder.saveError': "Couldn't create invoice",
  'finance.builder.cancel': 'Cancel',
  'finance.builder.saving': 'Saving…',
  'finance.builder.submit': 'Create invoice',
  // Finance — payments
  'finance.payments.title': 'Payments',
  'finance.payments.subtitle': 'Record and verify client payments.',
  'finance.payments.record': 'Record payment',
  'finance.payments.empty': 'No payments yet.',
  'finance.payments.loadError': "Couldn't load payments",
  'finance.payments.verify': 'Verify',
  'finance.payments.verifyError': "Couldn't verify payment",
  'finance.payments.col.date': 'Date',
  'finance.payments.col.client': 'Client',
  'finance.payments.col.invoice': 'Invoice',
  'finance.payments.col.amount': 'Amount',
  'finance.payments.col.method': 'Method',
  'finance.payments.col.status': 'Status',
  'finance.payments.col.actions': 'Actions',
  'finance.payments.status.pending': 'Pending',
  'finance.payments.status.verified': 'Verified',
  'finance.payments.status.void': 'Void',
  'finance.payments.form.title': 'Record payment',
  'finance.payments.form.invoiceId': 'Invoice ID',
  'finance.payments.form.clientId': 'Client ID',
  'finance.payments.form.amount': 'Amount',
  'finance.payments.form.method': 'Method',
  'finance.payments.form.reference': 'Reference',
  'finance.payments.form.paymentDate': 'Payment date',
  'finance.payments.form.notes': 'Notes',
  'finance.payments.form.invalid': 'Please check the form and try again.',
  'finance.payments.form.saveError': "Couldn't record payment",
  'finance.payments.form.cancel': 'Cancel',
  'finance.payments.form.saving': 'Saving…',
  'finance.payments.form.submit': 'Save',
  // Finance — expenses
  'finance.expenses.title': 'Expenses',
  'finance.expenses.subtitle': 'Track lab expenses and supplier payments.',
  'finance.expenses.add': 'Add expense',
  'finance.expenses.empty': 'No expenses yet.',
  'finance.expenses.loadError': "Couldn't load expenses",
  'finance.expenses.col.date': 'Date',
  'finance.expenses.col.category': 'Category',
  'finance.expenses.col.payee': 'Payee',
  'finance.expenses.col.amount': 'Amount',
  'finance.expenses.col.method': 'Method',
  'finance.expenses.form.title': 'Add expense',
  'finance.expenses.form.category': 'Category',
  'finance.expenses.form.payee': 'Payee',
  'finance.expenses.form.amount': 'Amount',
  'finance.expenses.form.method': 'Method',
  'finance.expenses.form.methodNone': '- None -',
  'finance.expenses.form.reference': 'Reference',
  'finance.expenses.form.expenseDate': 'Expense date',
  'finance.expenses.form.notes': 'Notes',
  'finance.expenses.form.invalid': 'Please check the form and try again.',
  'finance.expenses.form.saveError': "Couldn't save expense",
  'finance.expenses.form.cancel': 'Cancel',
  'finance.expenses.form.saving': 'Saving…',
  'finance.expenses.form.submit': 'Save',
  // Manufacturing (M6)
  'mfg.title': 'Manufacturing',
  'mfg.subtitle': 'Shop-floor work queue and production logging',
  'mfg.empty': 'No cases in the production queue.',
  'mfg.loadError': 'Failed to load the work queue.',
  'mfg.log': 'Log',
  'mfg.col.caseNumber': 'Case #',
  'mfg.col.client': 'Client',
  'mfg.col.service': 'Service',
  'mfg.col.status': 'Status',
  'mfg.col.due': 'Due',
  'mfg.col.action': 'Action',
  'mfg.log.title': 'Log production',
  'mfg.log.station': 'Station',
  'mfg.log.stationNone': '- No station -',
  'mfg.log.operation': 'Operation',
  'mfg.log.material': 'Material',
  'mfg.log.machine': 'Machine',
  'mfg.log.quantity': 'Quantity',
  'mfg.log.durationMin': 'Duration (min)',
  'mfg.log.outcome': 'Outcome',
  'mfg.log.notes': 'Notes',
  'mfg.log.advance': 'Advance to next stage',
  'mfg.log.invalid': 'Please check the form and try again.',
  'mfg.log.saveError': 'Failed to save the production log.',
  'mfg.log.cancel': 'Cancel',
  'mfg.log.submit': 'Save log',
  'mfg.log.saving': 'Saving…',
  // Settings (M7)
  'settings.title': 'Settings',
  'settings.subtitle': 'Configure case numbering, lab identity and aligner pricing.',
  'settings.loadError': 'Failed to load settings.',
  'settings.saveError': "Couldn't save settings. Please try again.",
  'settings.invalid': 'Please check the highlighted fields.',
  'settings.save': 'Save',
  'settings.saving': 'Saving…',
  'settings.saved': 'Saved',
  'settings.numbering.title': 'Case numbering',
  'settings.numbering.numberPrefix': 'Case number prefix',
  'settings.numbering.invoicePrefix': 'Invoice prefix',
  'settings.numbering.resetInterval': 'Reset interval',
  'settings.numbering.includeYear': 'Include year in case numbers',
  'settings.numbering.previewLabel': 'Example case number:',
  'settings.identity.title': 'Lab identity',
  'settings.identity.labName': 'Lab name',
  'settings.identity.labAddress': 'Address',
  'settings.identity.labPhone': 'Phone',
  'settings.identity.labWhatsapp': 'WhatsApp',
  'settings.identity.labEmail': 'Email',
  'settings.pricing.title': 'Aligner pricing',
  'settings.pricing.intro': 'What a clinic pays per aligner tray. Courses up to the threshold bill at the standard rate; longer courses bill every tray at the bulk rate.',
  'settings.pricing.threshold': 'Bulk threshold (trays)',
  'settings.pricing.rateAtOrBelow': 'Standard rate (PKR / tray)',
  'settings.pricing.rateAbove': 'Bulk rate (PKR / tray)',
  'settings.pricing.previewLabel': 'Example:',
  'settings.pricing.note': 'Applies to cases priced from now on. Invoices already raised keep the price they were issued at.',
  // Users admin (M7)
  'users.title': 'Users',
  'users.subtitle':
    'Lab staff accounts. Clinic logins live on the clinic (Clinics → Portal); a patient login lives on their case.',
  'users.searchPlaceholder': 'Search users…',
  'users.new': 'New user',
  'users.empty': 'No users found.',
  'users.loadError': 'Failed to load users.',
  'users.toggleError': "Couldn't change the user's status.",
  'users.col.username': 'Username',
  'users.col.name': 'Name',
  'users.col.role': 'Role',
  'users.col.active': 'Active',
  'users.col.created': 'Created',
  'users.col.actions': 'Actions',
  'users.status.active': 'Active',
  'users.status.inactive': 'Inactive',
  'users.edit': 'Edit',
  'users.activate': 'Activate',
  'users.deactivate': 'Deactivate',
  'users.resetPassword': 'Reset password',
  'users.form.createTitle': 'New user',
  'users.form.editTitle': 'Edit user',
  'users.form.username': 'Username',
  'users.form.password': 'Password',
  'users.form.role': 'Role',
  'users.form.displayName': 'Display name',
  'users.form.email': 'Email',
  'users.form.clinicId': 'Clinic ID (optional)',
  'users.form.caseId': 'Case ID (optional)',
  'users.form.isActive': 'Active',
  'users.form.cancel': 'Cancel',
  'users.form.submit': 'Save',
  'users.form.saving': 'Saving…',
  'users.form.saveError': "Couldn't save the user. Please try again.",
  'users.form.invalid': 'Please check the highlighted fields.',
  'users.reset.title': 'Reset password',
  'users.reset.password': 'New password',
  'users.reset.submit': 'Reset',
  'users.reset.saving': 'Saving…',
  'users.reset.saveError': "Couldn't reset the password. Please try again.",
} as const;

export type MessageKey = keyof typeof en;
const dict: Record<string, string> = en;

export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  let s = dict[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, String(v));
  return s;
}
